import {Component, EventEmitter, OnInit, Output} from '@angular/core';

class HtmlElement {
}

@Component({
    selector: 'app-hover-handler',
    templateUrl: './hover-handler.component.html',
    styleUrls: ['./hover-handler.component.scss']
})
export class HoverHandlerComponent {

    @Output() handlerMouseEnter: EventEmitter<HtmlElement> = new EventEmitter<HtmlElement>();
    @Output() handlerMouseLeave: EventEmitter<void> = new EventEmitter<void>();

    private timer: any;

    constructor() {
    }


    onMouseEnter(anchor: HTMLDivElement) {
        this.timer = setTimeout(_ => this.handlerMouseEnter.emit(anchor), 300);
    }

    onMouseLeave() {
        this.handlerMouseLeave.emit();
        if (this.timer) {
            clearTimeout(this.timer);
        }
    }
}
